// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"ae2ea1f4","888":"5c20cfe3"}[chunkId] + ".chunk.js";
};